import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import SharedHelmet from "../Helmet";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds
} from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { BMR_EndPoint } from "./ConstantsHealthCalculator";
import BMRTable from "./BMRTable";
const TITLE = "Calculatrice BMR et metabolisme de base";
const DESCRIPTION =
  "Calculez votre metabolisme basal (BMR) avec plusieurs formules reconnues. Obtenez une base fiable pour estimer votre depense journaliere et planifier vos apports.";
const KEYWORDS =
  "calculatrice BMR, metabolisme de base, calories au repos, depense energetique, formule harris benedict, mifflin st jeor";
const OG_URL = "https://do-calculate.com/calculator/fr/bmr/";
const apiEndpoint = `${SERVER_URL}/${BMR_EndPoint}`;
function BMRCalculator() {
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [formula, setFormula] = useState("harrisBenedictRevised");
  const [bodyFatPercentage, setBodyFatPercentage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };
  const handleHeightChange = (event) => {
    setHeight(event.target.value);
  };
  const handleAgeChange = (event) => {
    setAge(event.target.value);
  };
  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };
  const handleFormulaChange = (event) => {
    setFormula(event.target.value);
  };
  const handleBodyFatPercentageChange = (event) => {
    setBodyFatPercentage(event.target.value);
  };
  const calculateBMR = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          weight,
          height,
          age,
          gender,
          formula,
          bodyFatPercentage,
        }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data.result.classification);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                La calculatrice (Calculatrice BMR) calcule le taux métabolique de base (BMR)
                qui est l'énergie dont le corps a besoin au repos complet pour maintenir
                les fonctions de base du corps telles que la respiration, la circulation
                sanguine et les autres fonctions organiques essentielles. La calculatrice
                du taux métabolique de base est affectée par des facteurs tels que le poids,
                la taille, l'âge, le sexe et le pourcentage de graisse corporelle. Le taux
                métabolique de base est calculé à l'aide de différentes équations telles que
                l'équation de Harris-Benedict et l'équation de Mifflin-St Jeor. Le taux
                métabolique de base est important pour estimer les besoins énergétiques
                quotidiens des individus et pour planifier les programmes diététiques et
                d'exercice physique.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Taux métabolique de base - Calcul BMR
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="height" className="form-label ms-2">
                      Taille
                    </label>
                  </b>
                  <input
                    type="number"
                    id="height"
                    value={height}
                    onChange={handleHeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="175"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">cm</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="weightNumber" className="form-label ms-2">
                      Poids
                    </label>
                  </b>
                  <input
                    type="number"
                    id="weightNumber"
                    value={weight}
                    onChange={handleWeightChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="65"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">kg</span>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="age" className="form-label ms-2">
                      Âge
                    </label>
                  </b>
                  <input
                    type="number"
                    id="age"
                    value={age}
                    onChange={handleAgeChange}
                    className="form-control"
                    style={{ width: "90%" }}
                    placeholder="30"
                    min="2"
                    max="120"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label>Sexe</label>
                  </b>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      id="male"
                      value="male"
                      checked={gender === "male"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label htmlFor="male" className="form-check-label">
                      Homme
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      name="gender"
                      id="female"
                      value="female"
                      checked={gender === "female"}
                      onChange={handleGenderChange}
                      className="form-check-input"
                    />
                    <label htmlFor="female" className="form-check-label">
                      Femme
                    </label>
                  </div>
                </div>
                <br />
                <div>
                  <b>
                    <label htmlFor="select" className="form-label ms-2">
                      Choisir la formule
                    </label>
                  </b>
                  <select
                    id="select"
                    className="form-select"
                    value={formula}
                    onChange={handleFormulaChange}
                  >
                    <option value="harrisBenedictRevised">
                      Harris Benedict Equation (Révisée)
                    </option>
                    <option value="harrisBenedictOriginal">
                      Harris-Benedict Equation (Originale)
                    </option>
                    <option value="mifflinStJeor">Mifflin-St Jeor</option>
                    <option value="schofield">Schofield</option>
                    <option value="oxford">Oxford</option>
                    <option value="katchMcArdle">Katch-McArdle</option>
                    <option value="cunningham">Cunningham</option>
                  </select>
                </div>
                <br />
                {(formula === "katchMcArdle" || formula === "cunningham") && (
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label ms-2">Pourcentage de graisse</label>
                    </b>
                    <input
                      type="number"
                      id="bodyFatPercentage"
                      value={bodyFatPercentage}
                      onChange={handleBodyFatPercentageChange}
                      className="form-control"
                      style={{ width: "90%" }}
                      placeholder="20"
                      min="2"
                      max="60"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">%</span>
                    </div>
                    <br />
                  </div>
                )}
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateBMR}
                       >
                    Calculer
                    </button>              </div>
              <div className="col-sm-12 col-md-7">
                {result && (
                  <div>
                    <div className="alert alert-success">
                      <h5>Résultats : </h5>
                      Votre taux métabolique de base: {result.bmr} calories.
                    </div>
                    <hr />
                    <BMRTable
                      formula={formula}
                      bmr={result.bmr}
                      Sedentary={result.DailyCalorieNeeded.Sedentary}
                      Exercise1_3={result.DailyCalorieNeeded.Exercise1_3}
                      Exercise4_5={result.DailyCalorieNeeded.Exercise4_5}
                      DailyExercise={result.DailyCalorieNeeded.DailyExercise}
                      IntenseExercise={
                        result.DailyCalorieNeeded.IntenseExercise
                      }
                      VeryIntenseExercise={
                        result.DailyCalorieNeeded.VeryIntenseExercise
                      }
                    ></BMRTable>{" "}
                  </div>
                )}
                {error && (
                  <div className="alert alert-danger">
                    <h5>Erreur : </h5>
                    {error}
                  </div>
                )}
                {isLoading && (
                  <div className="alert alert-info">
                    Calcul en cours...
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <RelatedLinks />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Le BMR est une estimation de depart. Pour un suivi utile, combinez ce chiffre avec votre niveau d'activite reel et observez votre evolution sur 2 a 4 semaines.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Qu'est-ce que le BMR ?</h3></div>
              <div className="info-section-body"><p>Le metabolisme de base (BMR) est l'energie minimale que votre corps depense au repos pour fonctionner: respiration, circulation, activite cerebrale et regulation thermique. C'est la base de tout calcul calorique fiable.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comment utiliser votre BMR ?</h3></div>
              <div className="info-section-body"><p>Pour estimer vos calories quotidiennes, multipliez votre BMR par un coefficient d'activite (TDEE): sedentaires 1,2; legerement actifs 1,375; moderement actifs 1,55; tres actifs 1,725. Utilisez ensuite un ajustement progressif selon votre objectif.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BMRCalculator;
